// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.survey-button[data-v-4440745c]{display:flex;align-items:center;position:fixed;right:0;z-index:10;transform:rotate(-90deg) translateY(-100%);transform-origin:top right}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
